<template>
  <div>
      <div v-if="item">
           <fields-list :name="`${index}_name`" :item="item" :fields="fields" @input="setValue" />
           <button class="btn btn-sm btn-danger item-delete" @click="$emit('remove', index)" ><i class="ti-trash"></i> </button>
      </div>
 
  </div>
</template>

<script>

import { multiKeyInit } from "@/plugins/functions";
export default {
   created(){

      this.fields =   [ {
              col:' col-12 col-md-12',
              key: "body",
              label: "text",
              type: "html",
              isMultiLang:true
       }];


      this.item =  JSON.parse(JSON.stringify(this.data));

      this.multiKeyInit(this.item, this);


      this.setValue(this.item);


  },
  props: {
    index: {
      default: null,
    },
    data: {
      default: null,
    },
  },
  methods: {
    multiKeyInit:multiKeyInit,
    
    async setValue(val){

        const langs =  Object.keys({...this.$store.state.languages});
        let translations = [];
        for(let i=0;i<langs.length;i++){
          await  translations.push({
                  locale:langs[i],
                  body: val[`body:${langs[i]}`]
              });
        } 
         const data =  await {type:'type-text', ...val, translations:translations};
        // console.log(data);
         this.$emit('input', data);
    }
  },
    data: () => ({
        item:{
          body:''
        },  
        fields: [
         
        ],
  }),
};
</script>
